export default __webpack_public_path__ + "static/media/Loader.e45e35ca.gif";